import { BaseToast } from "./BaseToast";
import { ToastProps } from "./types";

export const ErrorToast = ({ children, ...rest }: ToastProps) => {
  return (
    <BaseToast {...rest} toastType="error">
      {children}
    </BaseToast>
  );
};
